import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 111 13"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#0B0B0B",
  d: "M11.55 6.544c0 3.705-2.42 6.154-5.966 6.154h-4.34V.385h4.34c3.552 0 5.966 2.465 5.966 6.154v.005ZM2.705 1.631v9.827h2.88c2.847 0 4.44-1.933 4.44-4.914 0-2.98-1.593-4.913-4.44-4.913h-2.88ZM27.07 12.704V.39h8.263v1.24h-6.808v4.296h6.05v1.256h-6.05v4.275h6.823v1.24h-8.284l.006.005ZM52.197.39h1.477v11.073h6.585v1.24h-8.062V.392Zm24.953 0h1.476v11.073h6.585v1.24H77.15V.392Zm24.767 12.314V.39h8.263v1.24h-6.808v4.296h6.051v1.256h-6.051v4.275h6.823v1.24h-8.284l.006.006ZM18.495 8.056c.956 0 1.73-.78 1.73-1.74 0-.962-.774-1.741-1.73-1.741s-1.731.78-1.731 1.74c0 .962.775 1.741 1.73 1.741Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }